import jQuery from 'jquery';

const scroll = {
    init: () => {
        const seeMoreButtons = document.querySelectorAll('.splide-slide__see-more');

        const slideHero = () => {
            let scrollHeight = document.querySelector('.header--homepage').offsetHeight;
            window.scroll({
                top: scrollHeight
            })
        }

        seeMoreButtons.forEach(button => {
            button.addEventListener('click', slideHero);
        });
    }
}

export default scroll;